// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3KR3F","location":"Header_location__3cYPC"};